import React, { useState } from 'react';
import { Modal, Select, message } from 'antd';

const YearRangeModal = ({ visible, onClose, options, onSubmit }) => {
    const [startYear, setStartYear] = useState(null);
    const [endYear, setEndYear] = useState(null);

    const handleOk = () => {
        if (!startYear || !endYear) {
            message.warning('Please select both start and end years.');
            return;
        }

        if (parseInt(endYear) < parseInt(startYear)) {
            message.error('End year cannot be earlier than start year.');
            return;
        }

        onSubmit({ startYear, endYear });
        //setStartYear(null); this will be enabled if they want the state variables of the pop up to be null once selected
        //setEndYear(null);
        onClose();
    };

    return (
        <Modal
            title="Select Year Range"
            open={visible}
            onCancel={onClose}
            onOk={handleOk}
            okButtonProps={{ disabled: !startYear || !endYear }}
            destroyOnClose
        >
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <Select
                    placeholder="Start Year"
                    style={{ flex: 1, minWidth: 150 }}
                    value={startYear}
                    onChange={setStartYear}
                    options={options.map(y => ({ label: y.label, value: y.value }))}
                    showSearch
                />
                <Select
                    placeholder="End Year"
                    style={{ flex: 1, minWidth: 150 }}
                    value={endYear}
                    onChange={setEndYear}
                    options={options.map(y => ({ label: y.label, value: y.value }))}
                    showSearch
                />
            </div>
        </Modal>
    );
};

export default YearRangeModal;